<!--
    Componente Responsável por apresentar e ocultar o loading no projeto,
    podendo ser utlizados loadings em todas as sessões das struturas do projeto:

    - Template ( loading para o projeto inteiro )
    - Header   ( loading para somente o topo do projeto )
    - Sidebar  ( loading para somente o menu lateral do projeto )
    - Footer   ( loading para somente o rodapé do projeto )


    Para utilizar o componente loading deve seguir os seguintes passos:

    1) Importar o arquivo de eventos:
        import EventBusLoading from '@/_event-bus/_loadings.js/_event-bus/_loadings.js'

    2) No do compnente que irá chamar o loadding poderá ser utilizado os eventos para mostar e ocultar o loading:
        EventBusLoading.template([true ou false]);
        EventBusLoading.header([true ou false]);
        EventBusLoading.sidebar([true ou false]);
        EventBusLoading.main([true ou false]);
        EventBusLoading.footer([true ou false]);
 -->

<template>
    <div class="component-loading" :class="stateMetodo()">
        <svg class="spinner" viewBox="0 0 50 50" :style="size">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                classShowHide: '',
                size: {
                    width: this.state.size,
                    height: this.state.size,
                    margin: this.state.margin
                }
            }
        },
        props: {
            state: {
                type : Object,
                required: true
            }
        },
        methods: {
            stateMetodo() {
                let returned = '';

                if (this.state.show === true) {
                    if(this.state.size == '120px') {
                        returned = 'show fixed-position';
                    } else {
                        returned = 'show';
                    }
                } else if (this.state.show === false) {
                    setTimeout(()=> {
                        this.state.show = '';
                    }, 1000);
                    returned = 'hide';
                } else {
                    returned = '';
                }

                return returned;
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
@import '@sass/_variables.scss';


@keyframes loadingfullshow
{
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes loadingfullhide
{
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

.component-loading
{
    background-color: $loadgin-background-dark;
    height: 100%;
    width: 100%;
    z-index: 90909090;
    position: absolute;
    align-items: center;
    justify-content: center;
    width: 0;
    height: 0;
    display: none;

    &.show {
        display: block;
        width: 100%;
        height: 100%;
        display: flex;
        animation: loadingfullshow 1s;
        animation-fill-mode: forwards;
    }

    &.hide {
        display: block;
        width: 100%;
        height: 100%;
        display: flex;
        animation: loadingfullhide 1s;
        animation-fill-mode: forwards;
    }

    .spinner {
        animation: rotate 2s linear infinite;
        z-index: 2;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -25px 0 0 -25px;
        width: 50px;
        height: 50px;

        & .path {
            stroke: #e5f6fc;
            stroke-linecap: round;
            animation: dash 1.1s ease-in-out infinite;
        }
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
}

.fixed-position {
    position: fixed;
}
</style>
